import Cookies from 'js-cookie';
import { GESTIFY_REFRESH_TOKEN, GESTIFY_TOKEN } from '../utils';

export function removeGestifyTokenCookies() {
  Cookies.remove(GESTIFY_TOKEN);
  Cookies.remove(GESTIFY_REFRESH_TOKEN);
}

export const COOKIES_OPTIONS: Cookies.CookieAttributes = {
  secure: true,
  sameSite: 'Strict',
};

export function addGestifyTokenCookies({
  gestifyToken,
  gestifyRefreshToken,
}: {
  gestifyToken: string;
  gestifyRefreshToken: string;
}) {
  Cookies.set(GESTIFY_TOKEN, gestifyToken, COOKIES_OPTIONS);
  Cookies.set(GESTIFY_REFRESH_TOKEN, gestifyRefreshToken, COOKIES_OPTIONS);
}

export function getGestifyTokenCookies(): {
  gestifyToken: string | null;
  gestifyRefreshToken: string | null;
} {
  const gestifyToken = Cookies.get(GESTIFY_TOKEN) || null;
  const gestifyRefreshToken = Cookies.get(GESTIFY_REFRESH_TOKEN) || null;
  return {
    gestifyToken,
    gestifyRefreshToken,
  };
}
